import styled from "styled-components";
import Colors from "../../../../Constant/Colors";
import SmartImage from "../../../../Components/SmartImage";

export const Container = styled.div`
  display: ${(props) => (props.toggleSideBar ? "flex" : "none")};
  width: ${(props) => (props.toggleSideBar ? "25%" : "0px")};
  min-width: 250px;
  height: 95%;
  flex-direction: column;
  box-sizing: border-box;
  transition: width 0.9s ease-in-out;
  padding: 10px 0px;
  border-radius: 8px;
  margin-top:20px;
  box-shadow: 0px 4px 4.65px rgba(0, 0, 0, 0.30);
  background-color: ${Colors.whiteThemeColor};

  @media only screen and (max-width: 600px) {
      width: ${(props) => (props.toggleSideBar ? "180px" : "0px")};
    background-color: ${Colors.whiteThemeColor};
    z-index: 500;
    box-shadow: 1px 1px 5px 1px ${Colors.lightTxt};
  }
`;
export const MailList = styled.div`
  flex-direction: column;
  box-sizing: border-box;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;


`;
export const Icon = styled(SmartImage)`
  object-fit: contain;
`;

